import { render, staticRenderFns } from "./float-ball.mpx?vue&type=template&id=1cf4f7ba&isComponent&outputPath=components%2Ffloat-ball029a44da%2Findex"
import script from "./float-ball.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Ffloat-ball029a44da%2Findex"
export * from "./float-ball.mpx?vue&type=script&lang=js&isComponent&outputPath=components%2Ffloat-ball029a44da%2Findex"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports